import React from 'react';
import {Grid} from "@mui/material";

export interface IFailureProps {
    message?: any;
    type: string;
}

export function Failure(props: IFailureProps) {

    return (
        <>
            <div style={{
                width: '100%',
                backgroundColor: '#e34f5c',
                padding: '10px',
                marginBottom: '0px',
                color: 'white',
                marginTop: '20px'
            }}>
                <Grid container direction="row" spacing={2}>
                    <Grid item>
                       Mit Ihrem Zählerstand für {props.type} gab es ein Problem.<br/>
                            {props.message && <>{props.message}<br/></>}
                    </Grid>
                </Grid>

            </div>
        </>
    );

}